"use client";

import { refreshProviderIntel } from "@/app/actions";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";
import { useState } from "react";

export function ProviderRefresh({ targetId }: { targetId: string }) {
  const router = useRouter();
  const [pending, setPending] = useState(false);
  return (
    <Button
      variant="secondary"
      disabled={pending}
      onClick={async () => {
        setPending(true);
        await refreshProviderIntel(targetId);
        setPending(false);
        router.refresh();
      }}
    >
      {pending ? "Looking up public records..." : "Look up provider"}
    </Button>
  );
}
